import { render } from "./Index.vue?vue&type=template&id=bd636a6a&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-bd636a6a"

export default script